export default {
  pairCoinScales: {},
  myStakeDetail: {},
  myStakeData:[]
};
